// TODO: make all of these imports lazy
import MainSettings from './MainSettings'
import APITokens from '@/components/APITokens'
import WebHooks from '@/components/WebHooks'
import HiddenGroupList from './HiddenGroupList'
import BlockedUsers from './BlockedUsers'
import MainNotifications from './MainNotifications'
import ProfileForm from './ProfileForm'
import Feedback from './Feedback'
import Language from './Language'
import Diagnostics from './Diagnostics'
import Appearance from './Appearance'

export default MainSettings

const hiddenRoute = {
	name: 'hiddengroups',
	path: '/settings/hiddengroups',
	component: HiddenGroupList,
	meta: { titleKey: 'settings_option_hidden_groups' },
}

const tokensRoute = {
	name: 'apitokens',
	path: '/settings/apitokens',
	component: APITokens,
	meta: { titleKey: 'settings_option_api_tokens' },
}

const webhooksRoute = {
	name: 'webhooks',
	path: '/settings/webhooks',
	component: WebHooks,
	meta: { titleKey: 'settings_option_webhooks' },
}

const blockedRoute = {
	name: 'blockedusers',
	path: '/settings/blockedusers',
	component: BlockedUsers,
	meta: { titleKey: 'settings_option_blockedusers' },
}

const notificationsRoute = {
	name: 'mainnotifications',
	path: '/settings/notifications',
	component: MainNotifications,
	meta: { titleKey: 'settings_option_notifications' },
}

const appearanceRoute = {
	name: 'appearance',
	path: '/settings/appearance',
	component: Appearance,
	meta: { titleKey: 'settings_option_appearance' },
}

const profileRoute = {
	name: 'mainprofile',
	path: '/settings/profile',
	component: ProfileForm,
	meta: { titleKey: 'common_profile_label' },
}

const feedbackRoute = {
	name: 'feedback',
	path: '/settings/feedback',
	component: Feedback,
	props: {
		title: 'settings_option_feedback',
		description: 'settings_feedback_prompt',
	},
	meta: { titleKey: 'settings_option_feedback' },
}

const bugReportRoute = {
	name: 'bugreport',
	path: '/settings/report-a-bug',
	component: Feedback,
	props: {
		title: 'settings_option_bug',
		description: 'settings_reportbug_prompt',
	},
	meta: { titleKey: 'settings_option_bug' },
}

const diagnosticsRoute = {
	name: 'diagnostics',
	path: '/settings/diagnostics',
	component: Diagnostics,
	meta: { title: 'Diagnostics' },
}

const languageRoute = {
	name: 'language',
	path: '/settings/language',
	component: Language,
	meta: { titleKey: 'settings_option_translation' },
}

const mainRoute = {
	name: 'mainsettings',
	path: '/settings/:id',
	// component: () => import('@/components/MainSettings'),
	component: MainSettings,
	meta: { titleKey: 'settings_title' },
}

export const routes = [
	hiddenRoute,
	tokensRoute,
	webhooksRoute,
	blockedRoute,
	notificationsRoute,
	appearanceRoute,
	profileRoute,
	feedbackRoute,
	bugReportRoute,
	diagnosticsRoute,
	languageRoute,
	mainRoute,
]
